import {
  LoadStatus,
  ReportLoad
} from 'src/app/infrastructure/services/models/load.model';

export const mockReportLoads: ReportLoad[] = [
  {
    loadId: 'LOAD-CME-1710883200000-A1B2C3D4',
    createdAt: '2026-04-02T02:00:09.258',
    operation: 'P\u00f3liza Nueva',
    operationCode: '007',
    policyNumber: '000000123456',
    status: LoadStatus.CREATED,
    statusDescription: 'Creado',
    totalRecords: 100,
    processedRecords: 0,
    errorCount: 0
  },
  {
    loadId: 'LOAD-CME-1710883200000-A2B2C3D4',
    createdAt: '2026-04-03T04:28:09.258',
    operation: 'Modificaci\u00f3n',
    operationCode: '008',
    policyNumber: '000000654321',
    status: LoadStatus.PROCESSING,
    statusDescription: 'Procesando',
    totalRecords: 100,
    processedRecords: 45,
    errorCount: 0
  },
  {
    loadId: 'LOAD-CME-1710883200000-A3B2C3D4',
    createdAt: '2026-04-04T06:05:09.258',
    operation: 'P\u00f3liza Nueva',
    operationCode: '007',
    policyNumber: '000000789012',
    status: LoadStatus.FAILED,
    statusDescription: 'Fallido',
    totalRecords: 50,
    processedRecords: 50,
    errorCount: 0,
    message:
      'Error validando cliente: No se encontró identificación del tomador en el sistema.'
  },
  {
    loadId: 'LOAD-CME-1710883200000-A4B2C3D4',
    createdAt: '2026-04-05T08:28:09.258',
    operation: 'Renovaci\u00f3n',
    operationCode: '009',
    policyNumber: '000000345678',
    status: LoadStatus.COMPLETED,
    statusDescription: 'Completado',
    totalRecords: 80,
    processedRecords: 80,
    errorCount: 5
  }
];
